import React from 'react';

const Bell = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 13 15" ref={svgRef} { ...{ ...{width: "1em", height: "1em"}, ...props } }>
    <title>{title}</title>
    <defs>
      <path
        id="Bell_a"
        d="M1048.77 1511.93v-3.4c0-2.35-1.26-4.33-3.46-4.85v-.53a1.15 1.15 0 1 0-2.31 0v.53c-2.2.52-3.46 2.49-3.46 4.86v3.4l-1.54 1.53v.77h12.3v-.77zm-3.09 3.53h-3.06a1.54 1.54 0 1 0 3.06 0z"
      />
    </defs>
    <use fill="currentColor" xlinkHref="#Bell_a" transform="translate(-1038 -1502)" />
  </svg>
);

export default Bell;



// WEBPACK FOOTER //
// ./src/common/icons/Bell.js